import * as React from "react";

let counter = 0;
const useUniqueId = () => {
    return React.useMemo(() => "uniqueId_" + counter++, []);
};

export default useUniqueId;
